export default __webpack_public_path__ + "static/media/family-guy-css.32a91baa.gif";